import React from 'react';
import Info from './info/Info';
import Language from './language/Language';

function Footer(props) {
    return (
        <div className="bg-[#F2F8FB] flex flex-col justify-between tablet:flex-row box-border pt-[48px] pb-[48px] pl-[45px] pr-[45px] ">
            <div className="flex flex-col tablet:flex-row">
                <Info/>
            </div>
            <div className="flex flex-col desktop:flex-row">
                <Language/>
            </div>
        </div>
    );
}

export default Footer;
